/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Current_Event_TooltipInputs */



/**
* | output |
* | --- |
* | "The current event active on screen" |
*
* @param {Timing_Sync_Current_Event_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_current_event_tooltip = /** @type {((inputs?: Timing_Sync_Current_Event_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Current_Event_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'evenement actuellement actif a l'ecran")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das aktuelle Ereignis, das auf dem Bildschirm angezeigt wird")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'evento corrente attivo sullo schermo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текущее событие, активное на экране.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El evento actual activo en la pantalla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("屏幕上正在发生的事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画面上で現在アクティブなイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्क्रीन पर वर्तमान में सक्रिय इवेंट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O evento atual está ativo na tela.")
	return /** @type {LocalizedString} */ ("The current event active on screen")
});